import { defineMessages } from 'react-intl';

export const CrossroadPageMessages = defineMessages({
  headerContent: {
    id: 'app.common.action',
    defaultMessage: 'Akce',
  },
  title: {
    id: 'app.CrossroadPage.title',
    defaultMessage: 'Vyber akci',
  },
  meterIdentification: {
    id: 'app.common.meterIdentification',
    defaultMessage: 'Identifikace měřidla',
  },
  meterPasport: {
    id: 'app.CrossroadPage.meterPasport',
    defaultMessage: 'Pasport měřidla',
  },
  sensorInstallation: {
    id: 'app.CrossroadPage.sensorInstallation',
    defaultMessage: 'Osazení senzoru',
  },
  meterReplacement: {
    id: 'app.CrossroadPage.meterReplacement',
    defaultMessage: 'Výměna měřidla',
  },
  serviceInspection: {
    id: 'app.CrossroadPage.serviceInspection',
    defaultMessage: 'Servisní prohlídka',
  },
  meterList: {
    id: 'app.common.meterList',
    defaultMessage: 'Seznam měřidel',
  },
  settings: {
    id: 'app.common.settings',
    defaultMessage: 'Nastavení',
  },
  readingGroups: {
    id: 'app.common.readingGroups',
    defaultMessage: 'Odečtové skupiny',
  },
});
